import React, { useState } from "react";
import "./Contact.css";
import { toast } from "react-toastify";
import { FiMail, FiPhone, FiMapPin, FiClock } from "react-icons/fi";

const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setemail] = useState("");
  const [number, setnumber] = useState("");
  const [message, setmessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  const datasend = async (e) => {
    e.preventDefault();

    if (isSending) {
      return;
    }

    if (!name || !email || !number || !message) {
      return toast.error("Please fill in all fields.");
    }

    const formdata = {
      name,
      email,
      mobilenumber: number,
      message,
    };

    const processingToastId = toast.info("Sending message...");
    setIsSending(true);

    try {
      const res = await fetch("https://xpert-tech-backend.vercel.app/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formdata),
      });

      const data = await res.json();

      if (res.status === 200 && data.message) {
        toast.dismiss(processingToastId);
        toast.success(data.message);
        setName("");
        setemail("");
        setnumber("");
        setmessage("");
      } else {
        toast.dismiss(processingToastId);
        toast.error(data.message);
      }
    } catch (error) {
      toast.dismiss(processingToastId);
      toast.error("An error occurred. Please try again later.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <div className="contact-layout">
          {/* Left Side: Info */}
          <div className="contact-info">
            <div className="section-badge">Get in Touch</div>
            <h2 className="info-title">
              Let's craft your <br />
              <span className="gradient-text">Digital Success</span>
            </h2>
            <p className="info-desc">
              Have a visionary project in mind? Our engineering experts are
              ready to turn your complex challenges into seamless solutions.
            </p>

            <div className="info-cards">
              <div className="info-card">
                <div className="icon-box">
                  <FiMail />
                </div>
                <div className="card-text">
                  <h4>Email Us</h4>
                  <p>hr@xpertstech.net</p>
                </div>
              </div>
              <div className="info-card">
                <div className="icon-box">
                  <FiPhone />
                </div>
                <div className="card-text">
                  <h4>Whatsapp</h4>
                  <p>+923003967143</p>
                </div>
              </div>
              <div className="info-card">
                <div className="icon-box">
                  <FiMapPin />
                </div>
                <div className="card-text">
                  <h4>Our Location</h4>
                  <p>Gulberg III, Lahore, Punjab, Pakistan</p>
                </div>
              </div>
              <div className="info-card">
                <div className="icon-box">
                  <FiClock />
                </div>
                <div className="card-text">
                  <h4>Working Hours</h4>
                  <p>Mon - Sat: 9 AM - 8 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Form */}
          <div className="contact-form-wrapper">
            <div className="form-card">
              <form className="app-form" onSubmit={datasend}>
                <div className="form-row">
                  <div className="app-form-group">
                    <label>Full Name</label>
                    <input
                      className="app-form-control"
                      placeholder="John Doe"
                      type="text"
                      name="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="app-form-group">
                    <label>Email Address</label>
                    <input
                      className="app-form-control"
                      placeholder="john@example.com"
                      type="text"
                      name="email"
                      value={email}
                      onChange={(e) => setemail(e.target.value)}
                    />
                  </div>
                </div>

                <div className="app-form-group">
                  <label>Contact Number</label>
                  <input
                    className="app-form-control"
                    placeholder="+923003967143"
                    type="number"
                    name="number"
                    value={number}
                    onChange={(e) => setnumber(e.target.value)}
                  />
                </div>

                <div className="app-form-group message">
                  <label>Your Message</label>
                  <textarea
                    rows={4}
                    className="app-form-control"
                    placeholder="Tell us about your project or requirements..."
                    name="message"
                    value={message}
                    onChange={(e) => setmessage(e.target.value)}
                  />
                </div>

                <button
                  className="submit-btn"
                  type="submit"
                  disabled={isSending}
                >
                  <span>{isSending ? "Sending..." : "Send Message"}</span>
                  {isSending ? (
                    <span className="button-spinner" aria-hidden="true" />
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M5 12H19M19 12L12 5M19 12L12 19"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
